//import config from '../config';
import React,{Component} from "react";
//import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import modallogo from "./images/loader.gif";
//import Table from 'react-bootstrap/Table'
//import AdminNotification1 from "./AdminNotifications1";
import NotificationAdmin2 from "./NotificationAdmin2";
import NotificationAdmin1 from "./NotificationAdmin1";

const axios = require("axios");
const ref = React.createRef();
class AdminNotificationTab extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",modalbody:"Please wait...",modalimage:modallogo,isOpen:false};
  
        }
        showModal=()=>
        {
            this.setState({isOpen:true});
        }
        hideModal=()=>
        {
            this.setState({isOpen:false});
        }
    
    
    render(){
        return(

            <div className="containera1">
{/*}                <div style={{width:"100%",textAlign:"center", height:"100%"}} >*/}
                    <div > 
                        <Tabs
                            style={{marginLeft:"50px"}}

                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"block"});
                                                            
//                            else this.setState({value:newValue,tab1:"block",tab2:"none"});
                            }}
                            >
                            <Tab label="Add / New" style={{paddingTop:"0px"}} > </Tab> 
                            <Tab label="Edit / Remove"></Tab>
                        </Tabs>

                    </div>
                    <div  style={{display:this.state.tab1}}>
                            <NotificationAdmin1/>
                        </div>
{/*Tab 2*/}

                        <div  style={{display:this.state.tab2}}>
                            <NotificationAdmin2/>
                        </div>

{/*}                </div>*/}
                <br></br><br></br>
            </div>

    )}
}
export default AdminNotificationTab;